module.exports = __webpack_public_path__ + "img/info.0d0e47b0.svg";